import * as React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';
import Timer from './timer';
import { authstatus as Language } from '../../Util/language.json';
import PropTypesPreset from '../../Util/PropTypesPreset';

// authstatus
const propTypes = {
  auth: PropTypes.shape({
    expires: PropTypes.string,
    use_plan: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape(PropTypesPreset.history).isRequired,
  onClickSignOut: PropTypes.func.isRequired,
};
const defaultProps = {
  auth: {
    expires: '',
    trialExpires: {},
    use_plan: 'A_1day',
  },
  onClickSignOut: null,
};

// paid : お支払い
class AuthStatus extends React.PureComponent {
  constructor(props){
    super(props)
    this.logout = this.logout.bind(this);
    this.continue = this.continue.bind(this);
    this.isTrial = this.isTrial.bind(this);
  }
  logout () {
    this.props.onClickSignOut();
  }

  continue () {
    this.props.history.replace('/expired')
  }

  // 트라이얼 계정인지 체크
  isTrial () {
    const { use_plan } = this.props.auth;
    if (use_plan === 'A_1day') {
      return true;
    }
    return false;
  }

  render() {
    const { expires, use_plan } = this.props.auth;
    const isTrial = this.isTrial();
    return (
      <div className="auth--status">
        <div className="auth--body">
        {isTrial && (<ButtonBase onClick={this.continue}>
            <div className={'btn-pay'}>決済</div>
          </ButtonBase>
        )}
          <Timer
            className="info"
            before={isTrial ? Language.daytrial : Language.daypaid}
            time={ new Date(expires).getTime()}
            plan={use_plan}
          />
        </div>
        <ButtonBase onClick={this.logout}>
          <div className="btn-logout-container">
            <div className="btn-logout">{Language.signout}</div>
          </div>
        </ButtonBase>
      </div>
    );
  }
}

AuthStatus.propTypes = propTypes;
AuthStatus.defaultProps = defaultProps;

export default AuthStatus;
